/**
 * Pagina "ENISA Reports" — thread di notifica SRP (CRA Art.14(2)) per release, con link al
 * manuale utente ENISA della Single Reporting Platform in testa alla pagina.
 *
 * Route: /enisa-reports (il vecchio /srp fa redirect qui). Incorpora la lista dei thread SRP
 * (viste aperti / precedenti / tutti) senza il suo page-header.
 */

import { SrpListPage } from '../srp/SrpListPage.js';
import styles from '../srp/Srp.module.css';

/** Manuale utente ENISA della Single Reporting Platform (CRA SRP) per i manufacturer. */
export const ENISA_SRP_MANUAL_URL =
  'https://www.enisa.europa.eu/topics/product-security/single-reporting-platform-srp/cra-srp-ar-user-manual';

export function ReportPage() {
  return (
    <div data-testid="report-page">
      <div className={styles.pageHeader}>
        <h1 className={styles.pageTitle}>ENISA Reports</h1>
        <span className={styles.pageSubtitle}>CRA Art.14(2) — E10.6 / RF-6-3</span>
        <a
          href={ENISA_SRP_MANUAL_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.externalLink}
          data-testid="link-enisa-srp-manual"
        >
          Manuale utente ENISA CRA SRP ↗
        </a>
      </div>

      <SrpListPage embedded />
    </div>
  );
}
